export default {
  title: "Become a web ",
  "title-paragraph": "",
  "title-blue-cta": "Apply Now",
  "title-black-cta": "Learn More",
  "sub-header": "Our Approach",
  "sub-header-paragraph":
    "Training in computer programming significantly boosts your chances of finding long-term, good-paying employment. At the same time, we know that training opportunities are not always equally accessible to everyone. That’s why we have created a free programme in Athens that welcomes ALL who are eager to learn. Our aim is for you to become competitive in the tech job market through learning new skills and professional development support.",
  "page-section-2-header": "Our approach is innovative",
  "page-section-2-paragraph":
    "We incorporate collaborative, project-based learning with a strong focus on community to create a challenging, yet supportive programme.",
  "sections-0-header": "project based learning",
  "sections-0-paragraph":
    "From very early on, you will build real-life projects to prepare you for working in the tech industry. Along the way, you will acquire the necessary skills to continue your learning journey independently",
  "sections-1-header": "pair programming sessions",
  "sections-1-paragraph":
    "you will learn how to work in a team to build projects",
  "sections-2-header": "access to mentors",
  "sections-2-paragraph":
    "professionals-developers are available to answer your questions, help outside of class and guide you through your learning journey",
  "page-section-3-paragraph": "",
  "cards-0-header": "Apply",
  "cards-0-paragraph": "",
  "cards-1-header": "Study(Hard)",
  "cards-1-paragraph": "",
  "cards-2-header": "Job hunting",
  "cards-2-paragraph": "",
  "cards-3-header": "Card Header",
  "cards-3-paragraph": "Card Paragraph",
  "cards-4-header": "Card Header",
  "cards-4-paragraph": "Card Paragraph",
  "cards-5-header": "Card Header",
  "cards-5-paragraph": "Card Paragraph",
  partners: "Our partners",
  "partners-paragraph":
    "This is a collaboration between civil society partners",
  "human-rights": "https://www.humanrights360.org/",
  "common-ground": "https://commongroundgreece.org/",
  "echo-hub": "https://echo100plus.com/en",
};
